module.exports = __webpack_public_path__ + "static/media/dual-screen@2x.976a8a0a.png";